import {
  MerchantPricingVariant,
  type ProductCode,
} from "Infrastructure/Api/Api";
import type { ProductPricingVariants } from "Components/Hunter/Merchants/types";
import { type TFunction, Resources, useResource } from "Translations/Resources";
import { getVariantCategoryName } from "Utils/merchantPricingUtils";

const RESOURCES = Resources.Components.Merchant.Pricings;

const getPricingName = ({
  t,
  categoryName,
  isIndividual,
  totalFee,
  assignedCount,
}: {
  t: TFunction;
  categoryName: string | null;
  isIndividual: boolean;
  totalFee: number;
  assignedCount: number;
}) => {
  if (categoryName && isIndividual) {
    return t(RESOURCES.FeeWithCategoryFeeAndAssignedCount, {
      totalFee,
      categoryName,
      assignedCount,
    });
  }

  if (categoryName) {
    return t(RESOURCES.FeeWithCategoryAndFee, {
      totalFee,
      categoryName,
    });
  }

  if (isIndividual) {
    return t(RESOURCES.FeeWithFeeAndAssignedCount, {
      totalFee,
      assignedCount,
    });
  }

  return t(RESOURCES.FeeWithFee, { totalFee });
};

export const useProductPricingFeesList = (
  pricings: Array<ProductPricingVariants>,
  productCode?: ProductCode,
) => {
  const { t } = useResource();

  return pricings.map(
    ({ id, totalFee, merchantPricingVariant, assignedCount }) => {
      const categoryName = getVariantCategoryName(
        productCode,
        merchantPricingVariant,
        t,
      );

      const isIndividual =
        merchantPricingVariant === MerchantPricingVariant.Individual;

      const name = getPricingName({
        t,
        categoryName,
        isIndividual,
        totalFee,
        assignedCount,
      });

      return {
        id,
        code: id,
        name,
      };
    },
  );
};
